import { fork } from 'effector'

export const scope = fork()
